import React, { useState } from 'react';

import { Backdrop, Modal, Fade, TextField } from '@material-ui/core';
import CloseRounded from '@material-ui/icons/CloseRounded';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { CenterFlexCSS, StyledGrid, ColoredCircularProgress } from 'styles/common';

import { StyledIcon } from 'constants/icons';
import theme from 'constants/theme';

import { showErrorSnackbar } from 'services/snackbar';

import { ButtonFilled, ButtonOutlined } from 'uiToolkit/Button';
import { Typography13, Typography6 } from 'uiToolkit/Typography';

import { useJobFunctionCreationContext } from './GrowthSettings';

export default function JobFunctionCreationModal({}) {
  const dispatch = useDispatch();

  const { isOpen, onSave, closeJobFunctionCreationModal } = useJobFunctionCreationContext();

  const [jobFunctionName, setJobFunctionName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    setJobFunctionName(event.target.value);
  };

  const createJobFunction = () => {
    setLoading(true);
    onSave(jobFunctionName)
      .then((res) => {
        closeModal();
      })
      .catch((err) => {
        dispatch(showErrorSnackbar(err.message || 'some error occurred while saving job Function. Please retry.'));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const closeModal = () => {
    setJobFunctionName('');
    closeJobFunctionCreationModal();
  };

  return (
    <Modal
      role="job-function-creation-modal"
      aria-labelledby="Job Function Creation Modal"
      aria-describedby="This modal enable new job function creation"
      open={isOpen}
      onClose={closeModal}
      onBackdropClick={closeModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <Container>
          <ModalContainer>
            <StyledHeader closeModal={closeModal} />
            <StyledTextField
              fullWidth
              variant="outlined"
              placeholder="Enter function name here"
              value={jobFunctionName}
              onChange={handleChange}
            />
            <StyledGrid container justify="flex-end" topGutter={6}>
              <ButtonOutlined
                borderColor={theme.palette.primary.main}
                fontColor={theme.palette.primary.main}
                rightGutter={3}
                style={{ width: '160px', height: '40px' }}
                onClick={closeModal}
              >
                Discard
              </ButtonOutlined>
              <ButtonFilled style={{ width: '160px', height: '40px' }} onClick={createJobFunction}>
                {loading ? <ColoredCircularProgress color="white" size="smallest" padding="6px" /> : 'Save'}
              </ButtonFilled>
            </StyledGrid>
          </ModalContainer>
        </Container>
      </Fade>
    </Modal>
  );
}

const Header = ({ className, closeModal }) => (
  <div className={className}>
    <Typography6 color={theme.palette.text.blackv1} weight={100}>
      Add New Function
    </Typography6>
    <Typography13 color={theme.palette.grey.dark} topGutter={1}>
      Enter function name to get started
    </Typography13>
    <StyledIcon
      color="#000000"
      size="fixed24px"
      style={{ position: 'absolute', top: '0', right: '0.5rem' }}
      onClick={closeModal}
    >
      <CloseRounded />
    </StyledIcon>
  </div>
);

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  ${CenterFlexCSS};
  position: relative;
`;

const ModalContainer = styled.div`
  width: 550px;
  max-height: 70%;

  border-radius: 4px;

  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: stretch;

  padding: 1.5rem;
`;

const StyledHeader = styled(Header)`
  position: relative;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
  padding-bottom: 1.5rem;
`;

const StyledTextField = styled(TextField)`
  margin-top: 1.5rem;

  .MuiOutlinedInput-input {
    height: 2.5rem;
    padding: 0rem 1rem;
  }

  input {
    font-size: 14px;
  }
`;
